module.exports = __webpack_public_path__ + "static/media/arrow-down.87ac45b7.png";